import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { LinkButton, Responsive, UIHeading1, UIHeading2, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';
import * as styles from './PromoOffersList.css';
import { PromoOfferCardContainer } from '../../containers/PromoOfferCardContainer';
import { IPromoOffer } from '../../types/promoOffersSelection';
import { OffersSlider } from '../OffersSlider';
import { PromoOffersListingCard } from '../PromoOffersListingCard';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';

interface IFreshPromoListProps {
  title: string;
  subtitle: string;
  url: string;
  offers: IPromoOffer[];
  onListShow(): void;
  onListingClick(): void;
  onListingModalClick(): void;
  onPromoLabelClick(cardId: number): void;
}

const ITEMS_PER_DESKTOP_SCREEN = 4;

export const PromoOffersList: React.FC<IFreshPromoListProps> = ({
  title,
  subtitle,
  url,
  offers,
  onListShow,
  onListingClick,
  onListingModalClick,
  onPromoLabelClick,
}) => {
  const device = useDeviceType();

  const showListingCard = React.useMemo(
    () => device === 'desktop' && offers.length > ITEMS_PER_DESKTOP_SCREEN,
    [offers.length, device],
  );

  return (
    <div data-testid="PromoOffersList">
      <div className={styles['header']}>
        <div className={styles['header-text']}>
          <Responsive desktop tablet>
            <UIHeading1>{title}</UIHeading1>
            <UIText1>{subtitle}</UIText1>
          </Responsive>
          <Responsive phone>
            <UIHeading2>{title}</UIHeading2>
            <UIText2>{subtitle}</UIText2>
          </Responsive>
        </div>
        <Responsive desktop tablet>
          <LinkButton
            href={url}
            target="_blank"
            title="Больше предложений"
            onClick={onListingClick}
            theme="fill_white_primary"
            size="XS"
          >
            Больше предложений
          </LinkButton>
        </Responsive>
      </div>
      <ActionAfterViewObserver triggerOnce callback={onListShow} wrapper={false}>
        <div className={styles['container']}>
          <OffersSlider
            rightArrow={RoundArrowRight}
            leftArrow={RoundArrowLeft}
            itemGap="16px"
            itemsPerDesktopScreen={ITEMS_PER_DESKTOP_SCREEN}
          >
            {offers.map((_, index) => {
              return (
                <div key={index} className={styles['slide']} data-testid="PromoOfferSlide">
                  <PromoOfferCardContainer cardId={index} onPromoLabelClick={onPromoLabelClick} />
                </div>
              );
            })}
            {showListingCard && <PromoOffersListingCard onListingClick={onListingModalClick} url={url} />}
          </OffersSlider>
        </div>
      </ActionAfterViewObserver>
      <Responsive phone>
        <div className={styles['listing-button']}>
          <LinkButton
            href={url}
            target="_blank"
            title="Больше предложений"
            onClick={onListingClick}
            theme="fill_secondary"
            size="M"
            fullWidth
          >
            Больше предложений
          </LinkButton>
        </div>
      </Responsive>
    </div>
  );
};
